import React, { useContext, useEffect, useState } from 'react';
import { getActiveProducts, getCurrentSubscriptionForOrganisation, getSubscriptionParameters } from '../../API/Payment/Payment';
import { NUM_SEATS_CHANGED, PRICE_SELECTED } from '../../Context/Pricing/Events';
import { PricingContext } from '../../Context/Pricing/PricingContext';
import { SUBSCRIPTION_PLANS } from '../Shared/Subscription/SubscriptionInfo';
import EnterpriseCard from './EnterpriseCard';
import ProductCard from './ProductCard';

function PriceList({ numberOfSeats, interval, onSelect }) {

    const { state,dispatch } = useContext(PricingContext);
    const [ selectedOption, setSelectedOption ] = useState(null);

    const onProductCardSelectionChange =(e)=>{
        debugger
        const selectedOption = SUBSCRIPTION_PLANS.find(plan => (
            plan.name === e
        ))
        setSelectedOption(e);
      
     }

    const onProductCardChange =(e)=>{
        setSelectedOption(e);
        if (e !== "Enterprise" && onSelect) {
            debugger;
            const subscriptionParameters = state.subscriptions.find(subscription => (
                subscription.subscriptionName.trim().toLowerCase() === e.trim().toLowerCase()
            ));
            onSelect(subscriptionParameters);
            handleSeatChange(subscriptionParameters);
        }
     }

    // const planToShow = SUBSCRIPTION_PLANS.filter(plan => (
    //     plan.stripeProductId !== process.env.REACT_APP_STRIPE_FREE_PRODUCT_ID
    // ))

    function handlePlanSelect(plan) {
        dispatch({
            type: PRICE_SELECTED,
            payload: plan
        })
        handleSeatChange(plan);
    }

    function handleSeatChange(plan) {
        if (plan.stripeProductId === process.env.REACT_APP_STRIPE_FREE_PRODUCT_ID) {
            dispatch({
                type: NUM_SEATS_CHANGED,
                payload: 2,
            })
        } else if (
            state.numSeats === 2 &&
            plan.stripeProductId !== process.env.REACT_APP_STRIPE_FREE_PRODUCT_ID
        ) {
            dispatch({
                type: NUM_SEATS_CHANGED,
                payload: parseInt(state.currentOrganization.numSeats) === 2 ? 5 : parseInt(state.currentOrganization.numSeats),
            })
        } else if (
            plan.stripeProductId !== process.env.REACT_APP_STRIPE_FREE_PRODUCT_ID &&
            state.numSeats > parseInt(plan.maxSeats)
        ) {
            dispatch({
                type: NUM_SEATS_CHANGED,
                payload: parseInt(plan.maxSeats),
            })
        } else if (
            plan.stripeProductId !== process.env.REACT_APP_STRIPE_FREE_PRODUCT_ID &&
            state.numSeats < 3
        ) {
            dispatch({
                type: NUM_SEATS_CHANGED,
                payload: 5,
            })
        }
    }

    return (
        <>
        <div className="row gx-4 py-5">
            
            {
                SUBSCRIPTION_PLANS.map((plan, index) => (
                    <ProductCard
                        key={index}
                        product={plan}
                        selected={
                            state &&
                            state.currentSubscription &&
                            state.currentSubscription.stripeProductId &&
                            plan.stripeProductId === state.currentSubscription.stripeProductId
                        }
                        interval={interval}
                        numberOfSeats={numberOfSeats}
                        onSelect={() => handlePlanSelect(plan)} 
                        selectedOption={selectedOption}
                        onProductCardChange={onProductCardChange}
                        onProductCardSelectionChange={onProductCardChange}
                    />
                ))
            }
          </div>
        {/* <div><EnterpriseCard /></div>  */}
        </>
    )
}

export default PriceList;